import { render, staticRenderFns } from "./PermissionComponent.vue?vue&type=template&id=0d71555a&scoped=true&"
import script from "./PermissionComponent.vue?vue&type=script&lang=js&"
export * from "./PermissionComponent.vue?vue&type=script&lang=js&"
import style0 from "./PermissionComponent.vue?vue&type=style&index=0&id=0d71555a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d71555a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
